import * as React from 'react';
import { useState } from 'react';
import {
    SelectInput,
    AutocompleteInput,
    TextInput,
    ArrayInput,
    SimpleFormIterator,
    required} from 'react-admin';
import Transformer from '../../common/Transformer';
import { Grid } from "@mui/material";
import { SheetEditComponent } from './';
import { YesNoEnum } from '../../common/enum';
import { InputSeparator } from '../../components/input';
import HttpClient from '../../providers/HttpClient';
import { Edit, SimpleForm} from "src/enterprise/ra-rbac";

export const SheetEdit = () => {
    const transform = (data) => {
        Transformer(data, {
            remove: [
                'id',
                'createdAt',
                'updatedAt',
            ],
            update: {
                items: data.items?.map(is => ({
                    sheet: data.id, 
                    [!isNaN(is.attribute_key) ? 'attribute' : 'internalAttribute']: is.attribute_key,
                    name: is.name,
                    primaryKey: is.primary_key
                }), data)
            }
        });

        return data;
    };

    const [attributes, setAttributes] = useState([]);

    if (attributes.length === 0) {
        HttpClient(process.env.REACT_APP_API_BASE_URL+'/admin/importer/attributes', {
            method: 'GET'
        }).then(({ json }) => {
            setAttributes(json);

            return;
        });
    }

    return (
        <Edit component={SheetEditComponent} mutationMode="pessimistic" transform={transform}>
            <SimpleForm>
                <Grid container rowSpacing={1} columnSpacing={2}>
                    <Grid item sm={6} md={3}>
                        <TextInput disabled source="id"/>
                    </Grid>
                    <Grid item sm={12}>
                        <TextInput source="name" helperText="Set exact Sheet Name that is used in your Excel Document, by which will be be mapped in the process."  required/>
                    </Grid>
                </Grid>
                <Grid container item rowSpacing={1} columnSpacing={2}>
                    <Grid item sm={12} md={12}>
                        <InputSeparator title="Sheet Columns" />
                    </Grid>
                    <Grid item sm={12} md={12}>
                        <ArrayInput source="items">
                            <SimpleFormIterator inline>
                                    <TextInput source="name" />
                                    <AutocompleteInput source="attribute_key" size="small"  choices={attributes} optionText="code" validate={required()}/>
                                    <SelectInput source="primary_key" choices={YesNoEnum} validate={required()} defaultValue="no"/>
                            </SimpleFormIterator>
                        </ArrayInput>
                    </Grid>
                </Grid>
            </SimpleForm>
        </Edit>
    )
}